import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Tooltip } from "@mui/material";

import {
  EVOTRUX_BRAND_GREEN,
  EVOTRUX_FILTER_ACTIVE_INDICATOR,
  EVOTRUX_NAVY,
} from "constants/index";

export const COLLAPSED_RAIL_WIDTH_PX = 56;

interface Props {
  onClick: VoidFunction;
  totalCount?: number;
  hasActiveFilter?: boolean;
}

export function CollapsedShipmentRail(props: Props) {
  const { onClick, totalCount, hasActiveFilter = false } = props;

  const label =
    totalCount !== undefined ? `My Shipments (${totalCount})` : "My Shipments";
  const accessibleLabel = hasActiveFilter
    ? `Open ${label.toLowerCase()} (filters active)`
    : `Open ${label.toLowerCase()}`;

  return (
    <Tooltip title="Open your shipment list" placement="right" arrow>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        aria-label={accessibleLabel}
        sx={{
          width: `${COLLAPSED_RAIL_WIDTH_PX}px`,
          minHeight: "240px",
          backgroundColor: "white",
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: "12px",
          px: 0,
          cursor: "pointer",
          fontFamily: '"Quicksand", "Helvetica", "Arial", sans-serif',
          transition: "background-color 0.2s",
          color: EVOTRUX_NAVY,
          "&:hover": {
            backgroundColor: "grey.100",
          },
          "&:focus-visible": {
            outline: `2px solid ${EVOTRUX_BRAND_GREEN}`,
            outlineOffset: "2px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ChevronRightIcon sx={{ fontSize: 20, color: "#666666" }} />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              fontWeight: 600,
              fontSize: "15px",
              letterSpacing: "0.04em",
              color: "inherit",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Box>

          {hasActiveFilter && (
            <Box
              sx={{
                position: "absolute",
                top: "8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: EVOTRUX_FILTER_ACTIVE_INDICATOR,
              }}
            />
          )}
        </Box>
      </Box>
    </Tooltip>
  );
}
